import React from "react"

import LoadingPaw from "../../Components/LoadingPaw.js"
import type { FeatureFlagKey } from "../../../shared/lib/featureFlags.js"
import { useFeatureFlags } from "./useFeatureFlags.js"

interface FeatureGateProps {
  flag: FeatureFlagKey
  fallback: React.ReactNode
  children: React.ReactNode
}

export function FeatureGate({ flag, fallback, children }: FeatureGateProps) {
  const { flags, isLoading } = useFeatureFlags()

  if (isLoading) {
    return (
      <div className="h-60vh flex items-center justify-center">
        <LoadingPaw size="sm" />
      </div>
    )
  }

  return <>{flags[flag] ? children : fallback}</>
}
